import { Controller } from "react-hook-form";
import ReactSelect from "react-select";
const customStyles = {
  option: (provided, state) => ({
    ...provided,
    color: "#000",
    ":active": {
      backgroundColor: "#3182ce",
      color: "#fff",
    },
  }),
};
const SelectWithSearch = ({ label, name, options }) => {
  const labelSlug = label.replace(/\s+/g, "-").toLowerCase();
  return (
    <div data-testid={`${labelSlug}-container-test`}>
      <label className="inline-block mb-2" data-testid={`${labelSlug}-test`}>
        {label}
      </label>
      <Controller
        name={name}
        isClearable
        render={({ field, onChange, value }) => {
          let selectedOptionValue = null;
          if (value) {
            const slectedValue = options.find((o) => o.id === value);
            selectedOptionValue = slectedValue;
          }
          return (
            <ReactSelect
              {...field}
              styles={customStyles}
              value={selectedOptionValue}
              options={options}
              getOptionLabel={(option) => `${option.name}`}
              getOptionValue={(option) => `${option.id}`}
              onChange={(option) => onChange(option.id)}
            />
          );
        }}
      />
    </div>
  );
};

export default SelectWithSearch;
